import { useState } from 'react';
import { Button, Form, Header, List, Message } from 'semantic-ui-react';
import { extractPdfs } from '../api.js';

export default function UploadForm({ demo, onDone, onError }) {
  const [busy, setBusy] = useState(false);
  const [results, setResults] = useState(null);

  if (demo) {                                          // reading PDFs is done by the Python backend, so it can't run in the demo
    return (
      <section aria-labelledby="upload-heading">
        <Header as="h2" id="upload-heading" size="small">Add from PDF</Header>
        <Message info size="small">Reading PDFs needs the backend, which isn’t connected. Pick one of the demo reports below instead.</Message>
      </section>
    );
  }

  async function submit(e) {
    const form = e.currentTarget;
    const files = Array.from(form.elements.pdfs.files);
    if (!files.length) return;
    setBusy(true);
    try {
      const out = await extractPdfs(files, { approved: form.elements.approved.checked, overwrite: form.elements.overwrite.checked });
      setResults(out);
      form.reset();
      onDone(out);
    } catch (err) {
      onError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Form as="form" onSubmit={submit} aria-labelledby="upload-heading" className="upload">
      <Header as="h2" id="upload-heading" size="small">Add from PDF</Header>
      <Form.Field>
        <label htmlFor="pdfs" className="visually-hidden">Settlement Report PDFs</label>
        <input id="pdfs" name="pdfs" type="file" accept="application/pdf,.pdf" multiple required />
      </Form.Field>
      <Form.Checkbox name="approved" label="Mark as approved" />
      <Form.Checkbox name="overwrite" label="Replace reports already stored" />
      <Button type="submit" fluid loading={busy} disabled={busy} aria-busy={busy}>Read PDFs into the database</Button>
      {results && (
        <section aria-label="Upload results">
          <List size="small" className="results">
            {results.results.map((r, i) => (
              <List.Item key={i} className={r.status}>
                <strong>{r.file}</strong>: {r.status}{r.message ? ` – ${r.message}` : ''}{r.figures ? ` (${r.figures} figures)` : ''}
              </List.Item>
            ))}
          </List>
          {results.warnings.length > 0 && (
            <Message warning size="small" header={`${results.warnings.length} extractor warning(s)`} list={results.warnings} />
          )}
        </section>
      )}
    </Form>
  );
}
